import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';

import { useGetEconomicIndexQuery } from 'generated/graphql';



export interface IData {
  name: string;
  rate: string;
}

export function useQuery() {
  const years = _.times(4, (i) => DateTime.now().year - i);
  const tuple = useGetEconomicIndexQuery({
    variables: {
      options: {
        filter: {
          economicIndex: ['A191RL1Q225SBEA'],
          years
        }
      }
    }
  });



  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.economicIndices.find((index) => index.fredCode === 'A191RL1Q225SBEA')
        ?.historicalData.map((record) => ({
          name: record.date
            // Temporary for indices being off.
            .plus({
              hours: 6
            })
            .toFormat('Qq-yyyy'),
          rate: record?.value.toFixed(1) ?? '0'
        })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
